import useAuthErrorDialog from "@/lib/useAuthErrorDialog"
import { promiseTimeout } from "@vueuse/core"
import axios, { AxiosError, AxiosRequestConfig } from "axios"

declare module "axios" {
  interface AxiosRequestConfig {
    /**
     * The caller handles a 403 itself, and it does not mean the session has gone (a feature that is
     * switched off, say), so the "please log in again" dialog is not shown for it.
     */
    skipAuthErrorDialog?: boolean
  }
}

const RETRY_DELAY_IN_MS = 4000
interface RetryableAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean
}

const handleAuthErrorInterceptor = async (error: AxiosError) => {
  const originalRequest = error.config as RetryableAxiosRequestConfig
  const isAuthTokenRequired = !originalRequest.url?.startsWith("/api/v1/auth")
  const isRefreshTokenRequest = originalRequest.url?.startsWith(
    "/api/v1/auth/refresh",
  )

  if (
    error.code === AxiosError.ERR_NETWORK &&
    isRefreshTokenRequest &&
    !originalRequest._retry
  ) {
    originalRequest._retry = true
    await promiseTimeout(RETRY_DELAY_IN_MS)
    return axios(originalRequest)
  }

  if (
    error.response &&
    error?.response?.status === 403 &&
    isAuthTokenRequired &&
    !originalRequest.skipAuthErrorDialog
  ) {
    useAuthErrorDialog().showDialog()
  }

  throw error
}

export default handleAuthErrorInterceptor
